<template>
  <div>
    <div class="materials">
      <v-category-button v-for='material in materials'
        @click="setQuestionSortType(material.id)"
        :key="material.id"
        :type="material.type"
        :active="selectedQuestionSortType == material.id"
        :disabled="material.disabled"
      >
        {{material.text}}
      </v-category-button>
    </div>
  </div>
</template>

<script>
import VCategoryButton from '@/components/atoms/CategoryButton'
import config from '../../config'
export default {

  components: {
    VCategoryButton
  },

  computed: {
    materials() {
      return [
        {id: 1, text: config.sortTypeText[this.$store.state.conditions.selectedSearchType][1], type: 'page', disabled: false},
        {id: 2, text: 'ランダム', type: 'random', disabled: false},
      ]
    },
    selectedQuestionSortType() {
      return this.$store.state.conditions.selectedQuestionSortType;
    }
  },

  mounted() {
  },

  methods: {
    setQuestionSortType(id) {
      this.$store.commit('conditions/setSelectedQuestionSortType', {
        sortType: id
      })
    }
  },

  watch: {
  }
}
</script>

<style lang="stylus" scoped>
.materials
  max-width 800px

</style>
